import list from './customerMap'export default list